import { MediaQuery } from 'utils/media_query';
import './index.scss';

const $context = $('.q-profile-page');

$('.js-see-all-badges', $context).on('click', function (e) {
  e.preventDefault();
  $('.js-badges-tab', $context).tab('show');
});

if (MediaQuery.is('lt_md')) {
  const $context = '.q-profile-page';

  const goToLink = function () {
    $('html,body').animate(
      {
        scrollTop: $('#all-badges').offset().top
      },
      'slow'
    );
  };

  $('.js-see-all-badges', $context).on('click', function (e) {
    e.preventDefault();
    goToLink();
  });
}
